export { default } from './MediaPlusTextBlock';
